import { useEffect, useState, useRef } from 'react';
import { Formik } from 'formik';
import { Form } from 'react-bootstrap';
import _isArray from 'lodash/isArray';
import _sortBy from 'lodash/sortBy';
import _last from 'lodash/last';
import _isEmpty from 'lodash/isEmpty';
import { Select, Modal } from 'components';
import { useWindowSize } from 'hooks';
import { useStore } from 'store';
import { useStorage64Latin } from 'pages/Header/Content/hooks/useStorageBase64';
import { fetchMyGiftsTables } from 'store/actions/giftTable';
import { CURRENT_GIFT_TABLE, SEARS_PRODUCT } from 'constants/storage64';
// eslint-disable-next-line no-unused-vars
import arrow from 'assets/img/select-arrow-open.svg';
import { decodeStorage } from 'functions/storageBase64';
import { initialValues, schema } from './validations';
import { giftsTablesTransformer } from './transformers';
import styles from './styles.module.scss'


export default function ChangeGiftTableList({
  show,
  setShow,
  onChangeGiftTable = () => { },
  currentGiftTable = {},
}) {
  const [submitLabel, setSubmitLabel] = useState('Cambiar');
  const [titleModal, setTitleModal] = useState('Cambiar mesa de regalos');
  const [giftTableFlow] = useStore((state) => state.giftTableFlow.currentStep);
  const [active, setActive] = useState(false)

  const [giftsTablesOptions, setGiftsTablesOptions] = useState([]);
  const [, { isMobile }] = useWindowSize();
  const [listOfGiftsTables, dispatch] = useStore(
    (state) => state.giftTable.myListOfGiftsTables.results.list
  );
  const [storageGiftTable] = useStorage64Latin(CURRENT_GIFT_TABLE, {});
  const [agentTableId] = useStore((state) => state.commons.agentTableId);

  const formik = useRef({});

  const { setFieldValue = () => { } } = formik.current;

  const handleHide = () => {
    setFieldValue('selectedGiftTable', currentGiftTable.evento);
    setShow(false);
  };
  const handleSubmit = (values) => {
    const { selectedGiftTable } = values;

    if (selectedGiftTable) {
      const giftTable = listOfGiftsTables.find(
        ({ evento }) => evento === selectedGiftTable
      );
      onChangeGiftTable(giftTable || listOfGiftsTables[0]);
      setShow(false);
    }
  };

  useEffect(() => {
    dispatch(
      fetchMyGiftsTables({
        withLoader: Boolean(agentTableId),
        withModalError: false,
      })
    );
  }, [agentTableId]);

  useEffect(() => {
    const savedUrl = decodeStorage(SEARS_PRODUCT);
    /* if(savedUrl){
       setSubmitLabel('Aceptar');
       setTitleModal('Selecciona una mesa de regalos');
     } */
    if (_isArray(listOfGiftsTables)) {
      const transformedListOfGifts = giftsTablesTransformer(listOfGiftsTables);

      setGiftsTablesOptions(transformedListOfGifts);

      // console.log('listOfGiftsTables: ',listOfGiftsTables)
      // console.log('transformedListOfGifts: ',transformedListOfGifts)

      if (!currentGiftTable.evento && transformedListOfGifts[0]) {
        onChangeGiftTable(transformedListOfGifts[0]);
        setFieldValue(transformedListOfGifts[0].evento);
      }
    }
  }, [listOfGiftsTables, currentGiftTable]);

  useEffect(() => {
    const hasNewTableCreated = giftTableFlow === 6;

    if (
      (hasNewTableCreated || (agentTableId && _isEmpty(storageGiftTable))) &&
      listOfGiftsTables.length > 0
    ) {
      const orderListOfTables = _sortBy(listOfGiftsTables, ['id']);
      const newTable = agentTableId
        ? orderListOfTables.find(
          (giftTable) => giftTable.id === Number(agentTableId)
        )
        : _last(orderListOfTables);

      onChangeGiftTable(newTable);
    }
  }, [listOfGiftsTables, agentTableId, storageGiftTable]);

  return (
    <>
      <Formik
        innerRef={formik}
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form onSubmit={formikProps.handleSubmit}>
            {
              isMobile ? (
                giftsTablesOptions?.length <= 1
                  ? <div className="contSelectOneEvent">
                      <div className="selectOneEvent">Evento # {currentGiftTable.evento}</div>
                    </div>
                  :
                    <div className={styles.container}>
                      <div className={styles['current-event-container']} onClick={() => currentGiftTable && setActive(!active)}>
                        <span className={`${styles.event}`} data-active={active}>{currentGiftTable ? `Evento # ${  currentGiftTable.evento}` : 'Sin mesas'}</span>
                        {
                          currentGiftTable && <i className={`fa fa-angle-down ${styles.icon} ${active && styles.active}`} />
                        }
                      </div>
                      <div className={styles['options-container']} data-active={active}>
                        {
                          giftsTablesOptions.map(item => (
                            <span
                              key={item.id}
                              className={`${styles['event-value']} ${item.value === currentGiftTable.evento && styles.selected}`}
                              onClick={() => handleSubmit({ 'selectedGiftTable': item.value })}
                            >
                              Evento #{item.value} - {item.tipo}
                            </span>
                          ))
                        }
                      </div>
                    </div>
              ) : (
                giftsTablesOptions?.length <= 1
                  ? <div className="contSelectOneEvent">
                      <div className="selectOneEvent">Mesa # {currentGiftTable.evento}</div>
                    </div>
                  :
                    <div
                      onClick={formikProps.handleSubmit}
                      // onSubmit={formikProps.handleSubmit}
                      // show={show}
                      // onHide={handleHide}
                      // title={titleModal} 
                      // titleClassName="text-left text-md-center"
                      // className="mt-4 py-3 py-md-1"
                      // centered
                      // submitLabel={submitLabel}
                      type={isMobile ? 'single' : 'action'}
                    >
                      <Select
                        placeholder={currentGiftTable ? `Mesa # ${currentGiftTable.evento}` : 'Sin mesas'}
                        name="selectedGiftTable"
                        options={giftsTablesOptions}
                        className="selectmenu"
                        style={{ borderBottom: 'none !important' }}
                      />
                    </div>
              )
            }
          </Form>
        )}
      </Formik>
    </>
  );
}
